import React, { Component } from 'react';
import './animate.css';
import './App.css';
import Tone from 'tone';
import P5Wrapper from 'react-p5-wrapper';

var crusher1 = new Tone.BitCrusher(16).toMaster();
var crusher2 = new Tone.BitCrusher(16).toMaster();
var crusher3 = new Tone.BitCrusher(16).toMaster();
var crusher4 = new Tone.BitCrusher(16).toMaster();
var crusher5 = new Tone.BitCrusher(16).toMaster();
var crusher6 = new Tone.BitCrusher(16).toMaster();
var crusher7 = new Tone.BitCrusher(16).toMaster();
var crusher8 = new Tone.BitCrusher(16).toMaster();
var crusher9 = new Tone.BitCrusher(16).toMaster();
var crusher10 = new Tone.BitCrusher(16).toMaster();
var crusher11 = new Tone.BitCrusher(16).toMaster();
var crusher12 = new Tone.BitCrusher(16).toMaster();
var crusher13 = new Tone.BitCrusher(16).toMaster();
var crusher14 = new Tone.BitCrusher(16).toMaster();
var crusher15 = new Tone.BitCrusher(16).toMaster();

const sound1 = new Tone.Player({
  "url": "01_bass.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher1).toMaster();

const sound2 = new Tone.Player({
  "url": "02_bass.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher2).toMaster();

const sound3 = new Tone.Player({
  "url": "02_synth.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher3).toMaster();

const sound4 = new Tone.Player({
  "url": "03_bass.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher4).toMaster();

const sound5 = new Tone.Player({
  "url": "03_synth.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher5).toMaster();

const sound6 = new Tone.Player({
  "url": "03_piano.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher6).toMaster();

const sound7 = new Tone.Player({
  "url": "04_bass.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher7).toMaster();

const sound8 = new Tone.Player({
  "url": "04_synth.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher8).toMaster();

const sound9 = new Tone.Player({
  "url": "04_piano.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher9).toMaster();

const sound10 = new Tone.Player({
  "url": "04_kik.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 20.22,
  "volume": 0
}).connect(crusher10).toMaster();

const sound11 = new Tone.Player({
  "url": "05_bass.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 40.44,
  "volume": 0
}).connect(crusher11).toMaster();

const sound12 = new Tone.Player({
  "url": "05_synth.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 40.44,
  "volume": 0
}).connect(crusher12).toMaster();

const sound13 = new Tone.Player({
  "url": "05_piano.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 40.44,
  "volume": 0
}).connect(crusher13).toMaster();

const sound14 = new Tone.Player({
  "url": "05_kik.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 40.44,
  "volume": 0
}).connect(crusher14).toMaster();

const sound15 = new Tone.Player({
  "url": "05_bass2.mp3",
  "loop": "true",
  "loopStart": 0,
  "loopEnd": 40.44,
  "volume": 0
}).connect(crusher15).toMaster();

var canvasSize = 100;

if (window.innerWidth < 939) {

}
else {
  canvasSize = 100;
}

var players = [sound1, sound2, sound3, sound4, sound5, sound6, sound7, sound8, sound9, sound10, sound11, sound12, sound13, sound14, sound15];
var crushers = [crusher1, crusher2, crusher3, crusher4, crusher5, crusher6, crusher7, crusher8, crusher9, crusher10, crusher11, crusher12, crusher13, crusher14, crusher15];

var posterizeAmounts = [30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30];
var playStates = [true, null, null, null, null, null, null, null, null, null, null, null, null, null, null];

var endPhase = false;

var initialState = {
  effectAmount1: 30,
  effectAmount2: 30,
  effectAmount3: 30,
  effectAmount4: 30,
  effectAmount5: 30,
  effectAmount6: 30,
  effectAmount7: 30,
  effectAmount8: 30,
  effectAmount9: 30,
  effectAmount10: 30,
  effectAmount11: 30,
  effectAmount12: 30,
  effectAmount13: 30,
  effectAmount14: 30,
  effectAmount15: 30,
  crusher1: crusher1.bits,
  crusher2: crusher2.bits,
  crusher3: crusher3.bits,
  crusher4: crusher4.bits,
  crusher5: crusher5.bits,
  crusher6: crusher6.bits,
  crusher7: crusher7.bits,
  crusher8: crusher8.bits,
  crusher9: crusher9.bits,
  crusher10: crusher10.bits,
  crusher11: crusher11.bits,
  crusher12: crusher12.bits,
  crusher13: crusher13.bits,
  crusher14: crusher14.bits,
  crusher15: crusher15.bits,
  play1: playStates[0],
  play2: playStates[1],
  play3: playStates[2],
  play4: playStates[3],
  play5: playStates[4],
  play6: playStates[5],
  play7: playStates[6],
  play8: playStates[7],
  play9: playStates[8],
  play10: playStates[9],
  play11: playStates[10],
  play12: playStates[11],
  play13: playStates[12],
  play14: playStates[13],
  play15: playStates[14],
  phase0: false,
  phase1: false,
  phase2: false,
  phase3: false,
  phase4: false,
  phase5: false
}

class Balancer extends Component {

  constructor() {
    super();

    this.state = initialState;

    this.reset = this.reset.bind(this);
    this.zeroToOne = this.zeroToOne.bind(this);
    this.oneToTwo = this.oneToTwo.bind(this);
    this.twoToThree = this.twoToThree.bind(this);
    this.threeToFour = this.threeToFour.bind(this);
    this.fourToFive = this.fourToFive.bind(this);
    this.endIt = this.endIt.bind(this);
  }

  componentDidMount() {
    console.log("11");
    setInterval(() => {
      this.setState({
        effectAmount1: posterizeAmounts[0],
        effectAmount2: posterizeAmounts[1],
        effectAmount3: posterizeAmounts[2],
        effectAmount4: posterizeAmounts[3],
        effectAmount5: posterizeAmounts[4],
        effectAmount6: posterizeAmounts[5],
        effectAmount7: posterizeAmounts[6],
        effectAmount8: posterizeAmounts[7],
        effectAmount9: posterizeAmounts[8],
        effectAmount10: posterizeAmounts[9],
        effectAmount11: posterizeAmounts[10],
        effectAmount12: posterizeAmounts[11],
        effectAmount13: posterizeAmounts[12],
        effectAmount14: posterizeAmounts[13],
        effectAmount15: posterizeAmounts[14],
        crusher1: crusher1.bits,
        crusher2: crusher2.bits,
        crusher3: crusher3.bits,
        crusher4: crusher4.bits,
        crusher5: crusher5.bits,
        crusher6: crusher6.bits,
        crusher7: crusher7.bits,
        crusher8: crusher8.bits,
        crusher9: crusher9.bits,
        crusher10: crusher10.bits,
        crusher11: crusher11.bits,
        crusher12: crusher12.bits,
        crusher13: crusher13.bits,
        crusher14: crusher14.bits,
        crusher15: crusher15.bits,
        play1: playStates[0],
        play2: playStates[1],
        play3: playStates[2],
        play4: playStates[3],
        play5: playStates[4],
        play6: playStates[5],
        play7: playStates[6],
        play8: playStates[7],
        play9: playStates[8],
        play10: playStates[9],
        play11: playStates[10],
        play12: playStates[11],
        play13: playStates[12],
        play14: playStates[13],
        play15: playStates[14],
      })
    }, 200);
    this.setState({
      phase0: true
    });
  }

  reset(i) {
    this.setState({
      effectAmount1: 30,
      effectAmount2: 30,
      effectAmount3: 30,
      effectAmount4: 30,
      effectAmount5: 30,
      effectAmount6: 30,
      effectAmount7: 30,
      effectAmount8: 30,
      effectAmount9: 30,
      effectAmount10: 30,
      effectAmount11: 30,
      effectAmount12: 30,
      effectAmount13: 30,
      effectAmount14: 30,
      effectAmount15: 30,
    });
    players[i].start();
    crushers[i].bits = 16;
    playStates[i] = true;
  }

  zeroToOne() {
    this.setState({
      phase0: false,
      phase1: true
    })
    sound1.start();
  }

  oneToTwo() {
    this.setState({
      phase1: false,
      phase2: true,
    });
    posterizeAmounts[0] = 30;
    sound1.stop();
    crusher1.bits = 16;
    sound2.start();
    sound3.start();
    playStates[1] = true;
    playStates[2] = true;
  }

  twoToThree() {
    this.setState({
      phase2: false,
      phase3: true
    });
    posterizeAmounts[1] = 30;
    posterizeAmounts[2] = 30;
    sound2.stop();
    sound3.stop();
    crusher2.bits = 16;
    crusher3.bits = 16;
    sound4.start();
    sound5.start();
    sound6.start();
    playStates[3] = true;
    playStates[4] = true;
    playStates[5] = true;
  }

  threeToFour() {
    this.setState({
      phase3: false,
      phase4: true
    });
    posterizeAmounts[3] = 30;
    posterizeAmounts[4] = 30;
    posterizeAmounts[5] = 30;
    sound4.stop();
    sound5.stop();
    sound6.stop();
    crusher4.bits = 16;
    crusher5.bits = 16;
    crusher6.bits = 16;
    sound7.start();
    sound8.start();
    sound9.start();
    sound10.start();
    playStates[6] = true;
    playStates[7] = true;
    playStates[8] = true;
    playStates[9] = true;
  }

  fourToFive() {
    this.setState({
      phase4: false,
      phase5: true
    });
    posterizeAmounts[6] = 30;
    posterizeAmounts[7] = 30;
    posterizeAmounts[8] = 30;
    posterizeAmounts[9] = 30;
    sound7.stop();
    sound8.stop();
    sound9.stop();
    sound10.stop();
    crusher7.bits = 16;
    crusher8.bits = 16;
    crusher9.bits = 16;
    crusher10.bits = 16;
    sound11.start();
    sound12.start();
    sound13.start();
    sound14.start();
    sound15.start();
    playStates[10] = true;
    playStates[11] = true;
    playStates[12] = true;
    playStates[13] = true;
    playStates[14] = true;
  }

  endIt() {
    endPhase = true;
  }


  render() {
    return (
      <div className="App noselect">
        <div className={this.state.phase0 === true ? "phase0 animated-slow fadeIn" : "phase0-hide"}>
          <img className="begin" src="begin.png" alt="begin" onClick={() => {
            this.zeroToOne();
          }} />
        </div>
        <div className={this.state.phase0 === true ? "phase0 animated-slow fadeInAfterPause" : "phase0-hide"}>
          <img className="permission" src="per.png" alt="permission granted"  />
        </div>
        <div className={this.state.phase0 === true ? "exit-hide" : "exit animated-slow fadeInAfterPause"}>
          <img className="exit-img" src="exit.png" alt="exit" onClick={() => {
                             window.location.href = "../index.html";
          }} />
        </div>
        <div className={this.state.phase1 === true ? "phase1 animated-slow fadeIn" : "phase1-hide"}>
          <div className="sketch">
            <P5Wrapper sketch={sketch1} effectAmount={this.state.effectAmount1} />
          </div>
        </div>
        <div className={this.state.phase2 === true ? "phase2 animated-slow fadeIn" : "phase2-hide"}>
          <div className="sketch">
            <P5Wrapper sketch={sketch2} effectAmount={this.state.effectAmount2} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch3} effectAmount={this.state.effectAmount3} />
          </div>
        </div>
        <div className={this.state.phase3 === true ? "phase3 animated-slow fadeIn" : "phase3-hide"}>
          <div className="sketch">
            <P5Wrapper sketch={sketch4} effectAmount={this.state.effectAmount4} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch5} effectAmount={this.state.effectAmount5} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch6} effectAmount={this.state.effectAmount6} />
          </div>
        </div>
        <div className={this.state.phase4 === true ? "phase4 animated-slow fadeIn" : "phase4-hide"}>
          <div className="sketch sketch7">
            <P5Wrapper sketch={sketch7} effectAmount={this.state.effectAmount7} />
          </div>
          <div className="sketch sketch8">
            <P5Wrapper sketch={sketch8} effectAmount={this.state.effectAmount8} />
          </div>
          <div className="sketch sketch9">
            <P5Wrapper sketch={sketch9} effectAmount={this.state.effectAmount9} />
          </div>
          <div className="sketch sketch10">
            <P5Wrapper sketch={sketch10} effectAmount={this.state.effectAmount10} />
          </div>
        </div>
        <div className={this.state.phase5 === true ? "phase5 animated-slow fadeIn" : "phase5-hide"}>
          <div className="sketch">
            <P5Wrapper sketch={sketch11} effectAmount={this.state.effectAmount11} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch12} effectAmount={this.state.effectAmount12} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch13} effectAmount={this.state.effectAmount13} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch14} effectAmount={this.state.effectAmount14} />
          </div>
          <div className="sketch">
            <P5Wrapper sketch={sketch15} effectAmount={this.state.effectAmount15} />
          </div>
        </div>
        <div className="captions">
          <div className="resets">
            <img className={this.state.play1 !== false ? "reset-hide" : "reset-show"} onClick={() => { this.reset(0) }} src="restart.png" alt="restart" />
            <img className={this.state.play2 !== false && this.state.play3 !== false ? "reset-hide" : "reset-show"}
              onClick={
                () => {
                  this.reset(1);
                  this.reset(2);
                }
              } src="restart.png" alt="restart" />
            <img className={this.state.play4 !== false && this.state.play5 !== false && this.state.play6 !== false ? "reset-hide" : "reset-show"}
              onClick={
                () => {
                  this.reset(3);
                  this.reset(4);
                  this.reset(5);
                }
              } src="restart.png" alt="restart" />
            <img className={this.state.play7 !== false && this.state.play8 !== false && this.state.play9 !== false && this.state.play10 !== false ? "reset-hide" : "reset-show"}
              onClick={
                () => {
                  this.reset(6);
                  this.reset(7);
                  this.reset(8);
                  this.reset(9);
                }
              } src="restart.png" alt="restart" />
            <img className={this.state.play11 !== false && this.state.play12 !== false && this.state.play13 !== false && this.state.play14 !== false && this.state.play15 !== false ? "reset-hide" : "reset-show"}
              onClick={
                () => {
                  this.reset(10);
                  this.reset(11);
                  this.reset(12);
                  this.reset(13);
                  this.reset(14);
                }
              } src="restart.png" alt="restart" />
          </div>
          <div className="wingdings">
            <img id="img1" className={this.state.crusher1 < 7.1 && this.state.crusher1 > 5.1 && this.state.play1 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img2" className={this.state.crusher2 < 7.1 && this.state.crusher2 > 5.1 && this.state.play2 === true && this.state.play3 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img3" className={this.state.crusher3 < 7.1 && this.state.crusher3 > 5.1 && this.state.play3 === true && this.state.play2 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img4" className={this.state.crusher4 < 7.1 && this.state.crusher4 > 5.1 && this.state.play4 === true && this.state.play5 === true && this.state.play6 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img5" className={this.state.crusher5 < 7.1 && this.state.crusher5 > 5.1 && this.state.play4 === true && this.state.play5 === true && this.state.play6 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img6" className={this.state.crusher6 < 7.1 && this.state.crusher6 > 5.1 && this.state.play4 === true && this.state.play5 === true && this.state.play6 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img7" className={this.state.crusher7 < 7.1 && this.state.crusher7 > 5.1 && this.state.play7 === true && this.state.play8 === true && this.state.play9 === true && this.state.play10 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img8" className={this.state.crusher8 < 7.1 && this.state.crusher8 > 5.1 && this.state.play7 === true && this.state.play8 === true && this.state.play9 === true && this.state.play10 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img9" className={this.state.crusher9 < 7.1 && this.state.crusher9 > 5.1 && this.state.play7 === true && this.state.play8 === true && this.state.play9 === true && this.state.play10 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img10" className={this.state.crusher10 < 7.1 && this.state.crusher10 > 5.1 && this.state.play7 === true && this.state.play8 === true && this.state.play9 === true && this.state.play10 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img11" className={this.state.crusher11 < 7.1 && this.state.crusher11 > 5.1 && this.state.play11 === true && this.state.play12 === true && this.state.play13 === true && this.state.play14 === true && this.state.play15 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img12" className={this.state.crusher12 < 7.1 && this.state.crusher12 > 5.1 && this.state.play11 === true && this.state.play12 === true && this.state.play13 === true && this.state.play14 === true && this.state.play15 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img13" className={this.state.crusher13 < 7.1 && this.state.crusher13 > 5.1 && this.state.play11 === true && this.state.play12 === true && this.state.play13 === true && this.state.play14 === true && this.state.play15 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img14" className={this.state.crusher14 < 7.1 && this.state.crusher14 > 5.1 && this.state.play11 === true && this.state.play12 === true && this.state.play13 === true && this.state.play14 === true && this.state.play15 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
            <img id="img15" className={this.state.crusher15 < 7.1 && this.state.crusher15 > 5.1 && this.state.play11 === true && this.state.play12 === true && this.state.play13 === true && this.state.play14 === true && this.state.play15 === true ? "wingding-show animated fadeIn" : "wingding-hide"} src="cross.png" alt="+" ></img>
          </div>
        </div>
        <div className="link">
          <img className={this.state.crusher1 < 7.1 && this.state.crusher1 > 5.1 ? "link-show animated-slow fadeInAfterPause" : "link-hide"} src="continue.png" alt="continue" onClick={() => { this.oneToTwo(); }} />
          <img className={this.state.crusher2 < 7.1 && this.state.crusher2 > 5.1 && this.state.crusher3 < 7.1 && this.state.crusher3 > 5.1 ? "link-show animated-slow fadeInAfterPause" : "link-hide"} src="continue.png" alt="continue" onClick={() => { this.twoToThree(); }} />
          <img className={this.state.crusher4 < 7.1 && this.state.crusher4 > 5.1 && this.state.crusher5 < 7.1 && this.state.crusher5 > 5.1 && this.state.crusher6 < 7.1 && this.state.crusher6 > 5.1 ? "link-show animated-slow fadeInAfterPause" : "link-hide"} src="continue.png" alt="continue" onClick={() => { this.threeToFour(); }} />
          <img className={
            this.state.crusher7 < 7.1 && this.state.crusher7 > 5.1
              && this.state.crusher8 < 7.1 && this.state.crusher8 > 5.1
              && this.state.crusher9 < 7.1 && this.state.crusher9 > 5.1
              && this.state.crusher10 < 7.1 && this.state.crusher10 > 5.1 ? "link-show animated-slow fadeInAfterPause" : "link-hide"} src="continue.png" alt="continue" onClick={() => { this.fourToFive(); }} />
          <img className={
            this.state.crusher11 < 7.1 && this.state.crusher11 > 5.1
              && this.state.crusher12 < 7.1 && this.state.crusher12 > 5.1
              && this.state.crusher13 < 7.1 && this.state.crusher13 > 5.1
              && this.state.crusher14 < 7.1 && this.state.crusher14 > 5.1
              && this.state.crusher15 < 7.1 && this.state.crusher15 > 5.1 ? "link-show animated-slow fadeInAfterPause" : "link-hide"} src="endit.png" alt="end it" onClick={() => {
                this.endIt();
                setTimeout(() => {
                  window.location.href = "../index.html";
                }, 1700)
              }} />
        </div>
      </div>
    );
  }
}

function sketch1(p) {

  var img;

  p.preload = function preload() {
    img = p.loadImage("01.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[0] <= 2.1) {
        sound1.stop();
        playStates[0] = false;
        return
      }
      else {
        posterizeAmounts[0] = posterizeAmounts[0] - 0.4;
        crusher1.bits = crusher1.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[0]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[0] = props.effectAmount;
    }
  };

};

function sketch2(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("02.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[1] <= 2.1) {
        sound2.stop();
        playStates[1] = false;
        return
      }
      else {
        posterizeAmounts[1] = posterizeAmounts[1] - 0.4;
        crusher2.bits = crusher2.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[1]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[1] = props.effectAmount;
    }
  };

};

function sketch3(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("03.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[2] <= 2.1) {
        sound3.stop();
        playStates[2] = false;
        return
      }
      else {
        posterizeAmounts[2] = posterizeAmounts[2] - 0.4;
        crusher3.bits = crusher3.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[2]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[2] = props.effectAmount;
    }
  };
};

function sketch4(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("04.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[3] <= 2.1) {
        sound4.stop();
        playStates[3] = false;
        return
      }
      else {
        posterizeAmounts[3] = posterizeAmounts[3] - 0.4;
        crusher4.bits = crusher4.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[3]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[3] = props.effectAmount;
    }
  };
};

function sketch5(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("05.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[4] <= 2.1) {
        sound5.stop();
        playStates[4] = false;
        return
      }
      else {
        posterizeAmounts[4] = posterizeAmounts[4] - 0.4;
        crusher5.bits = crusher5.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[4]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[4] = props.effectAmount;
    }
  };
};

function sketch6(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("06.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[5] <= 2.1) {
        sound6.stop();
        playStates[5] = false;
        return
      }
      else {
        posterizeAmounts[5] = posterizeAmounts[5] - 0.4;
        crusher6.bits = crusher6.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[5]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[5] = props.effectAmount;
    }
  };
};

function sketch7(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("07.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[6] <= 2.1) {
        sound7.stop();
        playStates[6] = false;
        return
      }
      else {
        posterizeAmounts[6] = posterizeAmounts[6] - 0.4;
        crusher7.bits = crusher7.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[6]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[6] = props.effectAmount;
    }
  };
};

function sketch8(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("08.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[7] <= 2.1) {
        sound8.stop();
        playStates[7] = false;
        return
      }
      else {
        posterizeAmounts[7] = posterizeAmounts[7] - 0.4;
        crusher8.bits = crusher8.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[7]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[7] = props.effectAmount;
    }
  };
};

function sketch9(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("09.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[8] <= 2.1) {
        sound9.stop();
        playStates[8] = false;
        return
      }
      else {
        posterizeAmounts[8] = posterizeAmounts[8] - 0.4;
        crusher9.bits = crusher9.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[8]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[8] = props.effectAmount;
    }
  };
};

function sketch10(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("10.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
    p.noLoop();
  };

  p.draw = function draw() {

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[9] <= 2.1) {
        sound10.stop();
        playStates[9] = false;
        return
      }
      else {
        posterizeAmounts[9] = posterizeAmounts[9] - 0.4;
        crusher10.bits = crusher10.bits - 0.2;
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[9]);
  }

  p.mousePressed = function mouseIsPressed() {
    p.loop();
  }

  p.mouseReleased = function mouseIsReleased() {
    p.noLoop();
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[9] = props.effectAmount;
    }
  };
};

function sketch11(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("11.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
  };

  p.draw = function draw() {

    if (endPhase === true) {
      if (posterizeAmounts[10] > 2.1) {
        posterizeAmounts[10] = posterizeAmounts[10] - 0.4;
      }
      else {
        posterizeAmounts[10] = 2;
      }
      if (crusher11.bits > -3) {
        crusher11.bits = crusher11.bits - 0.2;
      }
      else {
        endPhase = false;
        for (var j = 0; j < players.length; j++) {
          players[j].stop();
        }
      }
    }

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[10] <= 2.1) {
        sound11.stop();
        playStates[10] = false;
        return
      }
      else {
        if (endPhase !== true) {
          posterizeAmounts[10] = posterizeAmounts[10] - 0.4;
          crusher11.bits = crusher11.bits - 0.2;
        }
        else {
          return
        }
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[10]);
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[10] = props.effectAmount;
    }
  };
};

function sketch12(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("12.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
  };

  p.draw = function draw() {

    if (endPhase === true) {
      if (posterizeAmounts[11] > 2.1) {
        posterizeAmounts[11] = posterizeAmounts[11] - 0.4;
      }
      else {
        posterizeAmounts[11] = 2;
      }
      if (crusher12.bits > -3) {
        crusher12.bits = crusher12.bits - 0.2;
      }
      else {
        endPhase = false;
        for (var j = 0; j < players.length; j++) {
          players[j].stop();
        }
      }
    }

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[11] <= 2.1) {
        sound12.stop();
        playStates[11] = false;
        return
      }
      else {
        if (endPhase !== true) {
          posterizeAmounts[11] = posterizeAmounts[11] - 0.4;
          crusher12.bits = crusher12.bits - 0.2;
        }
        else {
          return
        }
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[11]);
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[11] = props.effectAmount;
    }
  };
};

function sketch13(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("13.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
  };

  p.draw = function draw() {

    if (endPhase === true) {
      if (posterizeAmounts[12] > 2.1) {
        posterizeAmounts[12] = posterizeAmounts[12] - 0.4;
      }
      else {
        posterizeAmounts[12] = 2;
      }
      if (crusher13.bits > -3) {
        crusher13.bits = crusher13.bits - 0.2;
      }
      else {
        endPhase = false;
        for (var j = 0; j < players.length; j++) {
          players[j].stop();
        }
      }
    }
    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[12] <= 2.1) {
        sound13.stop();
        playStates[12] = false;
        return
      }
      else {
        if (endPhase !== true) {
          posterizeAmounts[12] = posterizeAmounts[12] - 0.4;
          crusher13.bits = crusher13.bits - 0.2;
        }
        else {
          return
        }
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[12]);
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[12] = props.effectAmount;
    }
  };
};

function sketch14(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("14.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
  };

  p.draw = function draw() {

    if (endPhase === true) {
      if (posterizeAmounts[13] > 2.1) {
        posterizeAmounts[13] = posterizeAmounts[13] - 0.4;
      }
      else {
        posterizeAmounts[13] = 2;
      }
      if (crusher14.bits > -3) {
        crusher14.bits = crusher14.bits - 0.2;
      }
      else {
        endPhase = false;
        for (var j = 0; j < players.length; j++) {
          players[j].stop();
        }
      }
    }

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[13] <= 2.1) {
        sound14.stop();
        playStates[13] = false;
        return
      }
      else {
        if (endPhase !== true) {
          posterizeAmounts[13] = posterizeAmounts[13] - 0.4;
          crusher14.bits = crusher14.bits - 0.2;
        }
        else {
          return
        }
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[13]);
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[13] = props.effectAmount;
    }
  };
};

function sketch15(p) {

  var img;
  p.preload = function preload() {
    img = p.loadImage("15.png");
  }

  p.setup = function () {
    p.createCanvas(canvasSize, canvasSize);
    p.frameRate(25);
  };

  p.draw = function draw() {

    if (endPhase === true) {
      if (posterizeAmounts[14] > 2.1) {
        posterizeAmounts[14] = posterizeAmounts[14] - 0.4;
      }
      else {
        posterizeAmounts[14] = 2;
      }
      if (crusher15.bits > -3) {
        crusher15.bits = crusher15.bits - 0.2;
      }
      else {
        endPhase = false;
        for (var j = 0; j < players.length; j++) {
          players[j].stop();
        }
      }
    }

    if (p.mouseIsPressed && p.mouseX < canvasSize && p.mouseX > 0 && p.mouseY > 0 && p.mouseY < canvasSize) {
      if (posterizeAmounts[14] <= 2.1) {
        sound15.stop();
        playStates[14] = false;
        return
      }
      else {
        if (endPhase !== true) {
          posterizeAmounts[14] = posterizeAmounts[14] - 0.4;
          crusher15.bits = crusher15.bits - 0.2;
        }
        else {
          return
        }
      }
    }
    p.image(img, 0, 0, canvasSize, canvasSize);
    p.filter(p.POSTERIZE, posterizeAmounts[14]);
  }

  p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
    if (props.effectAmount) {
      posterizeAmounts[14] = props.effectAmount;
    }
  };
};

export default Balancer;


// WEBPACK FOOTER //
// ./src/Balancer.js